import { createSlice } from "@reduxjs/toolkit";
import services from "../services";

interface PostDescriptionState {
    data: Record<string, string>;
    loading: boolean;
    error: boolean;
}

const initialState: PostDescriptionState = {
    data: {},
    loading: false,
    error: false,
};

const postDescriptionSlice = createSlice({
    name: "postDescription",
    initialState,
    reducers: {
        updatePostDescriptionSuccess: (state, action) => {
            const { postId, description } = action.payload;
            state.data[postId] = description;
        },
        updatePostDescriptionFailure: (state) => {
            state.error = true;
        },
        setLoading: (state, action) => {
            state.loading = action.payload;
        },
    },
});

export const { updatePostDescriptionSuccess, updatePostDescriptionFailure, setLoading } =
    postDescriptionSlice.actions;

export default postDescriptionSlice.reducer;

export const patchPostDescription =
    (file_name: string, description: string) =>
    async (dispatch: any) => {
        try {
            dispatch(setLoading(true));
            await services.updatePostDescription(file_name, description);
            dispatch(updatePostDescriptionSuccess({ file_name, description }));
            return true;
        } catch (err) {
            console.error("Erro ao atualizar descrição do post:", err);
            dispatch(updatePostDescriptionFailure());
            return false;
        } finally {
            dispatch(setLoading(false));
        }
    };

